<template>
  <ul :class="dense ? 'py-1 px-2' : ''">
    <TreeBranch
      class="item"
      v-for="type in sortedTypes"
      :key="type.id"
      :type="type"
      :editMode="editMode"
      :expandAll="expandAll"
      :collapseAll="collapseAll"
      :pagination="pagination"
      :headers="headers"
      :dense="dense"
      :search="search"
      :selectable="selectable"
    />
    <li
      class="item-header"
      v-if="$can('create', 'types') && editMode"
      @click="addNewType"
    >
      <v-progress-circular
        v-show="loading"
        indeterminate
        :width="2"
        :size="20"
        :style="{margin: '6px 8px'}"
      />

      <div class="inline-input base-type-input" v-show="showNewTypeInput && !loading">
        <v-text-field
          v-model.trim="newType"
          :class="showNewTypeInput ? 'input-group--focused' : ''"
          single-line
          hide-details
          solo
          light
          @keyup.enter="saveNewType"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn small icon
          @click.native.stop="saveNewType"
        >
          <v-icon color="success">mdi-check</v-icon>
        </v-btn>

        <v-btn small icon
          class="ml-0"
          @click.native.stop="cancelNewType"
        >
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-btn

      v-show="!showNewTypeInput && !loading"
      small
      icon
      @click="addNewType"
      >
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </li>
  </ul>
</template>

<script>
import { cloneDeep } from 'lodash/fp'
import { mapGetters, mapActions } from 'vuex'
import TreeBranch from './TreeBranch'
import sort from '@/sorts'

export default {
  name: 'Tree',
  components: {
    TreeBranch
  },
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    },
    search: String,
    headers: {
      type: Array,
      default () {
        return Object.freeze([
          {
            text: 'Time Added',
            value: 'timestamp',
            sortable: true,
            sort: 'number'
          },
          {
            text: 'Name',
            value: 'name',
            sortable: true,
            sort: 'string'
          },
          {
            text: 'Item Count',
            value: 'itemCount',
            sortable: true,
            sort: 'number'
          }
        ])
      }
    },
    pagination: {
      type: Object,
      default () {
        return {
          descending: false,
          sortBy: null
        }
      }
    },
    forceRootTypes: {
      type: Boolean,
      default: false
    },
    collapseAll: {
      type: Boolean,
      default: false
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showNewTypeInput: false,
      newType: 'New Type',
      loading: false
    }
  },
  computed: {
    sortedTypes () {
      return this.pagination.sortBy
        ? sort(cloneDeep(this.types), this.pagination.sortBy, this.pagination.descending, this.headers)
        : this.types
    },
    types () {
      return this.currentID && !this.forceRootTypes
        ? this.currentChildren
        : this.rootTypes
    },
    ...mapGetters('standardItems', {
      currentChildren: 'itemTypes/children/currentChildren',
      rootTypes: 'itemTypes/rootTypesByLevel',
      currentID: 'itemTypes/currentID',
      currentType: 'itemTypes/currentType',
      currentCrumbs: 'itemTypes/getCurrentCrumbs'
    })
  },
  methods: {
    changeSort (value) {
      if (!this.pagination) {
        this.pagination = {
          sortBy: value,
          descending: false
        }
      }
      if (this.pagination.sortBy === value) {
        this.pagination = { ...this.pagination, descending: !this.pagination.descending }
      } else {
        this.pagination = { ...this.pagination, sortBy: value }
        this.pagination = { ...this.pagination, descending: false }
      }
    },

    selectInput () {
      this.$nextTick(function () {
        console.log(this.$el.querySelector('input')) // => 'updated'
        this.$el.querySelector('.base-type-input input').select()
      })
    },
    async saveNewType () {
      console.log('saving base itemType')

      if (
        // this.newType === 'New Type' ||
        !this.newType ||
        !this.newType.trim().length
      ) return null

      this.loading = true

      const newTypeAdded = await this.create({
        newType: { name: this.newType },
        parent: this.currentType
      })
      console.log('newType: ', newTypeAdded)
      this.newType = 'New Type'

      this.showNewTypeInput = false
      this.loading = false
    },
    cancelNewType () {
      this.showNewTypeInput = false
    },
    addNewType () {
      this.showNewTypeInput = true
      this.selectInput()
    },
    ...mapActions('standardItems', {
      'create': 'itemTypes/create'
    })
  },
  mounted () {
    console.log('TREE MOUNTED')
    this.$store.dispatch('standardItems/setLoading', false)
  }
}
</script>

<style lang="stylus">
@import '~vuetify/src/stylus/settings/_colors.styl'

$height = calc(100vh - 212px)

.btn
  .btn-hover-icon
    transition: opacity 0.5s ease

.btn&:not(.active)
  .btn-hover-icon
    opacity: 0
    transition: opacity 0.5s ease

.btn:hover .btn-hover-icon
  opacity: 1

.item-header
  display: flex
  align-items: center
  min-height: 50px
  user-select: none
  font-size: 14px
  text-decoration: none

  &&--dense
    white-space: nowrap
    font-size: 13px
    min-height: auto

  &:not(.leaf):hover
    cursor: pointer

.item-header .hover-btn
  display: none

.item-header:hover .hover-btn
  display: block

.endpoint
  // padding-left: 20px

.item-header:hover
    // cursor: pointer
    background-color: rgba(88, 88, 88, .2)

.theme--dark
  .item-header
    color: $shades.white

.theme--light
  .item-header
    color: rgba(0,0,0,0.87)

.inline-header
  display: flex
  align-items: center
  width: 100%

.inline-input
  display: flex
  align-items: center
  width: 100%

ul
  padding-left: 1em
  line-height: 1.5em
  list-style-type: none

.sub-list
  margin-left: 1.55em
  border-left: 1px solid hsla(0, 0%, 100%, 0.12)

  &&--dense
    padding-left: 0

.branch__selected
  margin: 0

.branch--selectable
  &:hover
    cursor: pointer

</style>
